/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RequestTrackingVersionStatsResponse,
    RequestTrackingVersionStatsResponseFromJSON,
    RequestTrackingVersionStatsResponseFromJSONTyped,
    RequestTrackingVersionStatsResponseToJSON,
} from './RequestTrackingVersionStatsResponse';

/**
 * 
 * @export
 * @interface RequestTrackingStatisticsResponse
 */
export interface RequestTrackingStatisticsResponse {
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingStatisticsResponse
     */
    totalRequests?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingStatisticsResponse
     */
    successCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingStatisticsResponse
     */
    errorCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingStatisticsResponse
     */
    successRate?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingStatisticsResponse
     */
    errorRate?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingStatisticsResponse
     */
    avgExecutionTime?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingStatisticsResponse
     */
    maxExecutionTime?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingStatisticsResponse
     */
    minExecutionTime?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingStatisticsResponse
     */
    uniqueDevices?: number;
    /**
     * 
     * @type {Array<RequestTrackingVersionStatsResponse>}
     * @memberof RequestTrackingStatisticsResponse
     */
    versionStats?: Array<RequestTrackingVersionStatsResponse>;
}

export function RequestTrackingStatisticsResponseFromJSON(json: any): RequestTrackingStatisticsResponse {
    return RequestTrackingStatisticsResponseFromJSONTyped(json, false);
}

export function RequestTrackingStatisticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestTrackingStatisticsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalRequests': !exists(json, 'totalRequests') ? undefined : json['totalRequests'],
        'successCount': !exists(json, 'successCount') ? undefined : json['successCount'],
        'errorCount': !exists(json, 'errorCount') ? undefined : json['errorCount'],
        'successRate': !exists(json, 'successRate') ? undefined : json['successRate'],
        'errorRate': !exists(json, 'errorRate') ? undefined : json['errorRate'],
        'avgExecutionTime': !exists(json, 'avgExecutionTime') ? undefined : json['avgExecutionTime'],
        'maxExecutionTime': !exists(json, 'maxExecutionTime') ? undefined : json['maxExecutionTime'],
        'minExecutionTime': !exists(json, 'minExecutionTime') ? undefined : json['minExecutionTime'],
        'uniqueDevices': !exists(json, 'uniqueDevices') ? undefined : json['uniqueDevices'],
        'versionStats': !exists(json, 'versionStats') ? undefined : ((json['versionStats'] as Array<any>).map(RequestTrackingVersionStatsResponseFromJSON)),
    };
}

export function RequestTrackingStatisticsResponseToJSON(value?: RequestTrackingStatisticsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalRequests': value.totalRequests,
        'successCount': value.successCount,
        'errorCount': value.errorCount,
        'successRate': value.successRate,
        'errorRate': value.errorRate,
        'avgExecutionTime': value.avgExecutionTime,
        'maxExecutionTime': value.maxExecutionTime,
        'minExecutionTime': value.minExecutionTime,
        'uniqueDevices': value.uniqueDevices,
        'versionStats': value.versionStats === undefined ? undefined : ((value.versionStats as Array<any>).map(RequestTrackingVersionStatsResponseToJSON)),
    };
}

